package com.eladfinish.bible.contest.ui.components.dialogs

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorAccent
import com.eladfinish.bible.contest.dont_show_again
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun DontShowAgain(
    modifier: Modifier = Modifier,
    checked: Boolean = false,
    onCheckedChange: (Boolean) -> Unit,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Checkbox(
            colors = CheckboxDefaults.colors(
                checkedColor = colorResource(resource = SharedRes.colors.colorAccent),
                uncheckedColor = Color.DarkGray,
                checkmarkColor = Color.Black
            ),
            checked = checked,
            modifier = Modifier
                .padding(horizontal = 2.dp)
                .align(alignment = Alignment.CenterVertically),
            onCheckedChange = {
                onCheckedChange(it)
            },
        )
        Text(
            text = stringResource(resource = SharedRes.strings.dont_show_again),
            modifier = Modifier
                .align(alignment = Alignment.CenterVertically)
                .clickable(
                    onClick = {
                        onCheckedChange(!checked)
                    },
                ),
            color = Color.Black,
            fontSize = 17.sp,
            textAlign = TextAlign.Right,
        )
    }
}
